import React from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import { withRouter } from 'react-router';
import { parse as parseQuery } from 'query-string';
import { WHITE_LIST } from './whiteList';
import _pick from 'lodash/pick';

// Component
import CoreSnackbar from 'components/CoreSnackbar';

// Styles
import { withStyles } from '@material-ui/core/styles';

const styles = theme => {
  return {
    root: {
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      overflowY: 'hidden',
      '@media print': {
        height: 'auto',
      },
    },
  };
};

class CoreLayout extends React.PureComponent {
  static propTypes = {
    children: PropTypes.node,
    classes: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    storeParams: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const query = parseQuery(this.props.location.search);
    const validQuery = _pick(query, WHITE_LIST);
    this.props.storeParams(validQuery);
  }

  render() {
    const { classes, children } = this.props;

    return (
      <div className={classes.root}>
        {children}
        <CoreSnackbar />
      </div>
    );
  }
}

export default compose(
  withRouter,
  withStyles(styles),
)(CoreLayout);
